import React from "react";

const ActiveSessionDialog = ({ onCancel, onConfirm }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-sm mx-4">
        <h2
          className="text-lg font-bold text-gray-900 mb-2"
          style={{ fontFamily: "Urbanist, sans-serif" }}
        >
          Active Session Detected
        </h2>
        <p
          className="text-gray-500 text-sm mb-6"
          style={{ fontFamily: "Urbanist, sans-serif" }}
        >
          Another session is already active for this account. Do you want to log out of the other session and continue?
        </p>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 py-3 border-2 border-gray-200 rounded-xl text-gray-700 font-semibold hover:bg-gray-50 transition-all duration-200 cursor-pointer"
            style={{ fontFamily: "Urbanist, sans-serif" }}
          >
            No, Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-all duration-200 cursor-pointer"
            style={{ fontFamily: "Urbanist, sans-serif" }}
          >
            Yes, Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActiveSessionDialog;